<template lang="pug">
md-table-card
  form(novalidate='', @submit.stop.prevent='search')
    .filters
      md-layout(md-align='end')
        md-layout(md-flex='33', md-align='end')
          md-layout
            md-input-container
              label Search
              md-input(v-model.lazy='searchText',  v-on:keypress.enter="search()" )
          md-layout(md-flex='15', v-if='searchText != ""')
            md-button.md-icon-button.btn(@click='cleanSearchText')
              md-icon.icon(md-iconset="fa fa-trash-alt")
          md-layout(md-flex='10')
            md-button.md-icon-button.btn(type='submit', :disabled='loading')
              md-icon.icon(md-iconset="fa fa-search")

  stitch-loader(v-if='loading', :loading='loading', :size='45')

  div(v-show='hasAccountsToDisplay', :md-sort='sort.name', :md-sort-type='sort.type', @sort='onSort')
    div.titleLine.styleRow
        p.rowElements(md-sort-by='name') Name
        p.rowElements Billing Contact
        p.rowElements(md-sort-by='lastUpdated') Updated
        p.rowElements
    div.styleRow(v-for='account in accounts', :key='account._id')
      div.rowElements {{ account.name }}
      div.rowElements {{ account.billing_contact.first_name }} {{ account.billing_contact.last_name }} {{ account.billing_contact.email }}
      div.rowElements {{ account.lastUpdated | moment('from') }}
      div.rowElements.iconsContainer
        md-button.md-icon-button.md-raised.btn(@click='editAccount(account._id)')
          md-icon(md-iconset="fa fa-pencil-alt")

  md-table-pagination(
  v-show='hasAccountsToDisplay',
  :md-size='currentPagination.size',
  :md-total='totalAccounts',
  :md-page='currentPagination.page',
  md-label='Accounts',
  md-separator='of',
  :md-page-options='[5, 10, 25, 50]',
  @pagination='onPageChanged'
  )

  md-layout(v-if='hasNoResults' md-align='center')
    span#no-results.md-subheading
      md-icon.md-accent(md-iconset="fa fa-exclamation-circle")
      | No items to show
</template>

<script>
  import accountService from '../../services/accountService';
  import stitchLoader from '../../shared-components/Loader';

  export default {
    components: {
      stitchLoader
    },
    data() {
      return {
        accounts: [],
        totalAccounts: null,
        loading: false,
        currentPagination: {
          page: 1,
          size: 5
        },
        sort: {
          name: 'lastUpdated',
          type: 'desc'
        },
        searchText: ''
      };
    },
    computed: {
      searchParams() {
        const params = {
          offset: this.currentPagination.size * (this.currentPagination.page - 1),
          limit: this.currentPagination.size,
          sortBy: this.sort.name,
          sortOrder: this.sort.type
        };
        if (this.searchText) {
          Object.assign(params, { name: this.searchText });
        }
        return params;
      },
      hasAccountsToDisplay() {
        return !this.loading && this.accounts.length > 0;
      },
      hasNoResults() {
        return !this.loading && this.accounts.length === 0;
      }
    },
    methods: {
      onPageChanged(paginationParams) {
        this.currentPagination = paginationParams;
        this.search();
      },
      onSort(sortParams) {
        this.sort = sortParams;
        this.search();
      },
      search() {
        this.loading = true;
        accountService.getList(this.searchParams)
          .then((response) => {
            this.accounts = response.data.accounts;
            this.totalAccounts = response.data.total;
          })
          .catch((error) => {
            console.error('Error while retrieving the list of accounts', error);
          })
          .then(() => {
            this.loading = false;
          });
      },
      editAccount(accountId) {
        this.$router.push({
          name: 'EditAccount',
          params: {
            id: accountId
          }
        });
      },
      cleanSearchText(){
        this.searchText = '';
        this.search()
      },
    },
    mounted() {
      this.search();
    }
  };
</script>

<style lang="scss" scoped>
  .filters {
    margin-top: 10px;
    padding: 2px 20px;
  }
  .search-btn {
    margin-top: 16px;
  }
  .md-table {
    .md-sortable.md-sorted, .md-sortable:hover {
      color: #0198cf;
    }
  }
  #no-results {
    padding: 20px;
    .md-icon {
      margin-right: 5px;
    }
  }

  .titleLine {
  border-bottom: solid;
  border-bottom-width: 1px;
  border-bottom-color: rgba(153, 155, 155, 0.486);
}

.styleRow {
  align-items: center;
  display: flex;
  margin-bottom: 10px;
  text-align: center;
}

.styleRow p {
  font-weight: 600;
}

.rowElements {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.iconsContainer {
  padding: 4px 0px;
  display: flex;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/shared-components/account/AccountTable.vue